import { httpGet } from "@/api/connection";
import { EvidenceType } from "./evidence-types.types";

export type GetEvidenceTypesParams = {
  id: number | null;
};

export type GetEvidenceTypesResponse = EvidenceType[];

export type GetEvidenceTypesFn = (
  values?: GetEvidenceTypesParams
) => Promise<GetEvidenceTypesResponse>;

const getEvidenceTypes: GetEvidenceTypesFn = async (values) => {
  const { id } = values || {};
  if (id == null) return await httpGet(`/evidence-types`);
  else return await httpGet(`/evidence-types/${id}`);
};

export const EvidenceTypesAPI = {
  get: getEvidenceTypes,
};
